import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import TripForm from "./tripComponents/TripForm";

import { useAddTripMutation } from "store/services/tripApi";

const TripCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Trips", path: "/app/crm/trip/list" },
    { title: "New Trip" },
  ];

  // RTK Query
  const [addTrip, { isLoading }] = useAddTripMutation();

  const handleCreateTrip = async (data) => {
    try {
      const { _id } = await addTrip(data).unwrap();
      toast.success("Trip successfully created!");
      navigate(`/app/crm/trip/${_id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create trip!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <TripForm isBusy={isLoading} onSubmit={handleCreateTrip} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default TripCreateScreen;